import { useMemo, useContext } from 'react';
import { debugConsole } from './debug-console';
import { AnalyticsContext } from '../analytics-context';
export var useDebugConsole = function useDebugConsole() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    loggerProp = _ref.logger,
    debugProp = _ref.debug;
  var context = useContext(AnalyticsContext);
  var debugContext = context.debug,
    loggerContext = context.logger;
  var logger = loggerProp !== null && loggerProp !== void 0 ? loggerProp : loggerContext;
  var debug = debugProp !== null && debugProp !== void 0 ? debugProp : debugContext;
  var debugLog = useMemo(() => logger !== null && logger !== void 0 ? logger : debugConsole(debug), [debug, logger]);
  return {
    logger: debugLog,
    debug
  };
};
export default useDebugConsole;